import { StyledPropsTheme } from '../../types';
import parent from './standard';

export default Object.assign({}, parent, {
	COLOR_PRIMARY: '#3B8DFF', // 标准色
	COLOR_PRIMARY_LIGHT_O75: 'rgba(59, 141, 255, 0.75)', // 标准色75%透明
	COLOR_PRIMARY_LIGHT_010: 'rgba(59, 141, 255, 0.1)',
	COLOR_PRIMARY_LIGHT: '#6da9fe', // 标准色淡10%
	INPUT_FOCUS_BORDER_COLOR: 'rgba(59, 141, 255, 0.8)', // 输入框获取焦点后边框色
	TOGGLE_TRUE_BORDER_COLOR: '#3B8DFF',
	TOGGLE_TRUE_BACKGROUND_COLOR: '#3B8DFF',
}) as StyledPropsTheme;
